/**
 * 在给定的 HTML 字符串中，为所有 <a> 标签添加 target="_blank" 和 class="link" 属性。
 *
 * 此函数的目的是确保所有链接在新标签页中打开，并添加样式以匹配设计。
 *
 * @param {string} htmlString - 包含 <a> 标签的 HTML 字符串。
 * @returns {string} 添加了 target="_blank" 和 class="link" 属性的修改后的 HTML 字符串。
 *
 * @example
 * // 使用示例：
 * const originalHtml = '<p><a href="https://example.com">链接</a> 内容</p>';
 * const modifiedHtml = setTargetBlank(originalHtml);
 * console.log(modifiedHtml);
 * // 输出: '<p><a href="https://example.com" target="_blank" class="link">链接</a> 内容</p>'
 */
export function setTargetBlank(htmlString: string): string {
  // 使用正则表达式匹配 <a> 标签，并添加 target="_blank" 和 class="link"
  const modifiedHtml = htmlString.replace(
    /<a /g,
    '<a target="_blank" class="link" '
  )

  return modifiedHtml
}
